import moment from 'moment/moment';

import { get } from '../../../../../../shared/helpers';

export const checkLeadCreatedDate = (lead_created_date) => {
    if (lead_created_date) {
        const lead_create_date = moment(lead_created_date).valueOf();
        const currentDateMinus14Days = moment().startOf('day').subtract(14, 'days').valueOf();

        return currentDateMinus14Days <= lead_create_date;
    }

    return false;
};


export const checkLastValuationForHotList = (valuations) => {
    if (valuations && valuations.length) {
        const { created_date } = valuations[valuations.length - 1];
        if (created_date) {
            const currentDateMinusSevenDays = moment().subtract(7, 'days').format('YYYY-MM-DD');
            return created_date <= currentDateMinusSevenDays;
        }

        return false;
    }

    return false;
};

export const checkCurrentStatusForHotList = (statusId) => {
    const statuses = [
        // pending
        '5beabfe7f25bf5f49685abfb',
        // priced status
        '5c349213b01ff686c64b1dd4',
        // price given
        '5beabfe7f25bf5f49685abfc',
        // in progress
        '5bf2b498f83650911c3e3e80',
    ];
    return statuses.includes(statusId);
};

export const checkDivisionForHotList = (leadMarketing) => {
    const lead_division_id = get(leadMarketing, 'ref_lead_source._id');
    // ref_lead_source, id
    // 5be93e5f683059f77dbcef4c - Lead-o-matic
    // 5caf0ab9c2520a5844ef6a89 - SBF part-ex
    if (lead_division_id) {
        return lead_division_id !== '5be93e5f683059f77dbcef4c' && lead_division_id !== '5caf0ab9c2520a5844ef6a89';
    }

    return false;
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/Alerts/helpers.js